(ns practitest.frontend.tests.test-form.common)

(def test-form-id :test-main)
(def steps-form-id :test-steps)
(def copy-steps-form-id :copy-steps)

;; Current rails backend has issues with uuids as temp identifiers
;; so we're using this logic (similar to how it's done in `step_designs.js`
(defn random-step-id []
  (let [d (js/Date.)]
    (str (long d) (rand-int 10) (rand-int 10) (rand-int 10))))

(defn get-last-position
  [steps]
  (or (:position (last (sort-by :position (vals steps))))
      0))

(defn convert-test-type
  [type]
  (case type
    ;; Backend representation
    "StepDesign" :step
    "CallToTest" :call-to-test
    ;; Frontend representation
    :step :step
    :call-to-test :call-to-test
    ;; else
    :unknown))

;; Used both for backend and frontend representations
(defn init-step-form-object
    [step-id position dirty? new-step]
  (case (convert-test-type (:type new-step))
    :step
    (cond-> {:id step-id
             :new? dirty?
             :type :step
             :position position
             :fields {:name {:dirty? dirty?
                             :value (:name new-step)}
                      :description {:dirty? dirty?
                                    :value (:description new-step)}
                      :expected_results {:dirty? dirty?
                                         :value (:expected_results new-step)}}}
      ;; For new/copied steps, initialize empty stage attachments for copy-paste and drag-drop support
      dirty? (assoc :attachments {:stage []}))
    :call-to-test
    {:id step-id
     :new? dirty?
     :type :call-to-test
     :position position
     :callee-test (:callee_test new-step)}

    ;; else
    (do
      (js/console.warn "Invalid step object received" new-step)
      {})))

(defn insert-steps-at
  "Inserts new steps (as in form state) into steps map, recalculating positions if required"
  [steps new-steps add-position]
  (let [offset (count new-steps)
        ;; Init new map in case of empty form state
        steps (or steps {})
        steps-count (count steps)
        new-steps-indexed (map-indexed
                            (fn [idx new-step]
                              [(:id new-step) (assoc new-step :position (+ (inc idx) add-position))])
                            new-steps)]
    (if (< add-position steps-count)
      (into {}
            (mapcat
              (fn [{:keys [position id] :as step}]
                (cond
                  (< position add-position)
                  [[id step]]

                  (= position add-position)
                  (apply conj [[id step]] new-steps-indexed)

                  :else
                  [[id (assoc step :position (+ position offset))]])))
            (sort-by :position (vals steps)))
      (into steps new-steps-indexed))))

(defn index-of
  "Find the index of an item in a collection"
  [coll item]
  (first (keep-indexed
           (fn [idx i]
             (when (= item i)
               idx))
           coll)))

(defn next-item
  "Get the next item in a collection after the given item"
  [coll item]
  (let [index (index-of coll item)]
    (when index
      (if (>= (inc index) (count coll))
        nil
        (nth coll (inc index))))))

(defn prev-item
  "Get the previous item in a collection before the given item"
  [coll item]
  (let [index (index-of coll item)]
    (when index
      (if (< (dec index) 0)
        nil
        (nth coll (dec index))))))

(defn new-state-id
  "Generate a new unique state ID"
  []
  (str (random-uuid)))
